import { Component } from "react"
import PropTypes from "prop-types"
import { capitalize } from "humanize-plus"

import "./details_selection.scss"

export default function DetailsSelectionHOC({
  WrappedComponent,
  options,
  rootUrl,
  serviceTitle,
  serviceColor,
  serviceImage,
  initialSelection,
}) {
  class DetailsSelectionContainer extends Component {
    constructor(props) {
      super(props)
      this.state = {
        detailSelection:
          (initialSelection &&
            options.find(
              option => option.data.name == initialSelection.data.name
            )) ||
          options[0] ||
          null,
      }
    }

    dropdownSelect = e => {
      const selectionId = e.target.value
      this.updateDetails(selectionId)
    }

    updateDetails(selectionId) {
      const selected = options.find(item => item.data.id == selectionId)
      const id = selected.data.id != -1 ? selected.data.id : "all"
      const allUrlComponents = window.location.pathname.split("/")
      const lastUrlComponent = allUrlComponents[allUrlComponents.length - 1]
      const url =
        lastUrlComponent == rootUrl ? `${window.location.pathname}/${id}` : id
      window.history.pushState(window.history.state, selected.data.title, url)
      this.setState({ detailSelection: selected })
    }

    render() {
      const childProps = {
        ...this.props,
        data: this.state.data,
      }

      const DetailText =
        this.state.detailSelection != null
          ? this.state.detailSelection.ContentComponent
          : null

      return (
        <>
          <PremiumBreadCrumbs
            resource={rootUrl}
            selection={
              this.state.detailSelection.data.id !== -1
                ? this.state.detailSelection.data
                : null
            }
          />
          <div styleName="detail-selector" className="detail-selector">
            <div
              styleName="service-details"
              style={{ backgroundColor: serviceColor }}
            >
              <h3>{serviceTitle}</h3>
              <img src={serviceImage} alt={`${serviceTitle} logo`} />
            </div>
            <div
              styleName="detail-wrapper"
              style={
                this.state.detailSelection != null &&
                this.state.detailSelection.data.brand_color
                  ? {
                      backgroundColor: `#${this.state.detailSelection.data.brand_color}`,
                    }
                  : null
              }
            >
              <select
                onChange={this.dropdownSelect}
                value={
                  this.state.detailSelection
                    ? this.state.detailSelection.data.id
                    : null
                }
              >
                {options.map(item => (
                  <option key={item.data.id} value={item.data.id}>
                    {item.data.name}
                  </option>
                ))}
              </select>
              <div styleName="detail-text">
                {DetailText &&
                  DetailText(
                    this.state.detailSelection.data.name,
                    this.props.currentMetricDate
                  )}
              </div>
            </div>
          </div>
          <div styleName="plus">+</div>
          <WrappedComponent
            selection={this.state.detailSelection}
            onDetailSelect={this.updateDetails.bind(this)}
            {...childProps}
          />
        </>
      )
    }
  }

  DetailsSelectionContainer.propTypes = {
    currentMetricDate: PropTypes.string.isRequired,
  }

  return DetailsSelectionContainer
}

const PremiumBreadCrumbs = ({ resource, selection }) => (
  <div styleName="bread-crumbs">
    {selection ? (
      <a
        href={window.location.pathname.replace(
          `${resource}/${selection.id}`,
          resource
        )}
      >
        {capitalize(resource)}
      </a>
    ) : (
      <span>{capitalize(resource)}</span>
    )}
    {" > "}
    {selection?.category && resource === "services" && (
      <>
        <a
          href={window.location.pathname.replace(
            `${resource}/${selection.id}`,
            `categories/${selection.category.id}`
          )}
        >
          {selection.category.name}
        </a>
        {" > "}
      </>
    )}
    <span>
      {selection
        ? selection.name
        : `All ${resource === "applets" ? `Applets` : resource}`}
    </span>
  </div>
)

PremiumBreadCrumbs.propTypes = {
  resource: PropTypes.string.isRequired,
  selection: PropTypes.object,
}
